<template>
    <div>
        <!--<div class="dx-field">
            <router-link to="/login-form"><a>Log In</a></router-link>
        </div>-->
        <div class="login-header">
            <div><img class="medium-logo" src="../assets/DineSafeSquare.png"/></div>
            <div class="title dinesafe-purple">DineSafeVT</div>
            <div class=" dinesafe-label">Confirm your e-mail</div>
        </div>
        <div class='back-button'>
            <DxButton 
                icon="back"
                ref="btnBackRef" 
                type="normal"
                text="Back to Login"
                styling-mode="text" 
                @click="btnBackToLogin"               
            />
        </div>   

        <!--<div v-if="confirmEmailVisible" class='dx-field confirm-email'>Confirm your e-mail</div>-->
        <div v-if="emailSentVisible" class='dx-field email-sent center'>A link to reset your password has been sent to your e-mail address</div>

        <div v-if="txtEmailVisible" class='txt-email'>
            <DxTextBox
                ref='txtEmailRef'
                placeholder='E-mail'
                mode='email'
                :show-clear-button="true"
                :value.sync="email"
            >
                <DxValidator>
                    <DxRequiredRule message="E-mail is required" />
                    <DxEmailRule message="Email is invalid"/>
                </DxValidator>
            </DxTextBox>
        </div>

        <div v-if='btnResetPasswordVisible' class='center'>

            <DxButton 
                ref="btnResetPasswordRef" 
                type="default"
                text="Reset Password"
                styling-mode="contained" 
                width="180"
                @click="btnResetPassword"
            />
        </div>

        <div v-if="passwordResetVisible" class='dx-field'>A password-reset has been sent to your e-mail address</div>

        <PrivacyPolicyLink/>
    </div>
</template>
 
<script>
    import DxTextBox from "devextreme-vue/text-box";
    import {DxButton} from 'devextreme-vue';
    import DxValidationGroup from "devextreme-vue/validation-group";
    import DxValidator, { DxEmailRule, DxRequiredRule } from "devextreme-vue/validator";
    import DxValidationSummary from 'devextreme-vue/validation-summary';
    import PrivacyPolicyLink from "../../src/components/privacy-policy-link";

    export default {
        components: {
            DxTextBox,
            DxButton,
            DxValidationGroup,
            DxValidator,
            DxRequiredRule,
            DxValidationSummary,
            DxEmailRule,
            PrivacyPolicyLink,
        },
        props: {
            xemail: null,
        },
        data() {
            return {
                confirmEmailVisible: true,
                passwordResetVisible: false,
                txtEmailVisible: true,
                btnResetPasswordVisible: true,
                emailSentVisible: false,
                successPopupVisible: false,
                email: '',
            }
        },
        methods:{
            comparePasswords(e) {
                console.log("comparePasswords");

                //Check if the value for the Password matches the value for Confirm Password
                return this.$data.accountInfo.Password == this.$data.accountInfo.ConfirmPassword;
                //return true;
            },
            btnResetPassword(data, actions) {
                console.log('btnResetPassword');

                //Validate the e-mail address
                if (!data.validationGroup.validate().isValid) {
                    return;
                }

                //Hit the web service / run the stored proc
                this.$http.post(this.$store.state.appSettings.webServiceUrl + 'ForgotPassword',
                {
                    Email: this.email,
                }
                ).then(function(data){         
                    //var responseData = JSON.parse(data.body); 
                                    
                    this.confirmEmailVisible = false;
                    this.passwordResetVisible = false;
                    this.txtEmailVisible = false;
                    this.btnResetPasswordVisible = false; 
                    this.emailSentVisible = true;
                });  
            },
            btnBackToLogin(e){
                //Navigate to the Login page
                this.$router.push("/login-form");
            }
        }
    }
</script>

<style scoped>
    .center{
        display: flex; 
        justify-content: center;

        margin-top: 20px;
    }

    .confirm-email{
        padding-top: 20px;
    }

    .email-sent{
        
    }

    .txt-email{

    }
</style>